document.addEventListener('DOMContentLoaded', function () {
    // Find all inputs with the gf_readonly class
    var readonlyFields = document.querySelectorAll('.gf_readonly input, .gf_readonly textarea, .gf_readonly select');

    readonlyFields.forEach(function(field) {
        field.readOnly = true;
    });
});
